<svelte:head>
    <title>The Phoenix Pages - Login</title>
</svelte:head>

<script>
	import { onMount } from 'svelte';

    onMount(async () => {
        window.location = 'https://discord.com/api/oauth2/authorize?client_id=834733070522777680&redirect_uri=https%3A%2F%2Fphoenix-pages.izmichael.com%2Fauth&response_type=code&scope=identify';
        // window.location = 'https://discord.com/api/oauth2/authorize?client_id=834733070522777680&redirect_uri=http%3A%2F%2Flocalhost:5000%2Fauth&response_type=code&scope=identify';
    });
</script>